<template>
  <b-modal
      v-bind="$props"
      :id="id"
      centered
      footer-class="border-0 pt-0"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
  >
    <div class="text-center py-2">
      <div class="d-flex justify-content-center mb-3">
        <img :src="AlertIcon" alt="Alert Icon" width="40" height="40" />
      </div>
      <h4>{{ conflictTitle }}</h4>
      <p class="m-0 text-muted">{{ conflictDescription }}</p>
    </div>
    <template #modal-footer>
      <b-button
          class="w-100 m-0"
          variant="light"
          @click="hide"
      >
        {{ $t('Close') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import ConfirmationModal from '@/components/modals/confirmation-modal.vue'
import AlertIcon from '@/assets/icons/AlertIcon.svg'

export default {
  name: 'purchase-plan-action-conflict-dialog',
  extends: ConfirmationModal,
  props: {
    id: {default: 'purchase-plan-action-conflict-dialog-modal'},
    hideHeader: {default: true},
    title: {default: ''},
  },
  data() {
    return {
      AlertIcon,
      action: 'approve',
    };
  },
  computed: {
    conflictTitle() {
      return this.action === 'reject'
          ? this.$t('purchase_plans.modal_messages.reject_conflict_title')
          : this.$t('purchase_plans.modal_messages.approve_conflict_title')
    },
    conflictDescription() {
      return this.action === 'reject'
          ? this.$t('purchase_plans.modal_messages.reject_conflict_description')
          : this.$t('purchase_plans.modal_messages.approve_conflict_description')
    },
  },
  methods: {
    show(action = 'approve') {
      this.action = action === 'reject' ? 'reject' : 'approve'
      this.$bvModal.show(this.id)
    },
    hide() {
      this.$bvModal.hide(this.id)
    },
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .modal-body {
    color: var(--neutral-gray-800, #454646);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .modal-footer {
    border: none;
  }
}
</style>
